import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import restaurantReducer from './slices/restaurantSlice';
import tablesReducer from './slices/tablesSlice';
import ordersReducer from './slices/ordersSlice';
import productsReducer from './slices/productsSlice';
import notificationsReducer from './slices/notificationsSlice';
import themeReducer from './slices/themeSlice';
import cloudPrintReducer from './slices/cloudPrintSlice';
import dashboardPrivacyReducer from './slices/dashboardPrivacySlice';
import { baseApi } from '../services/baseApi';
import { autofacturaApi } from '../services/autofacturaApi';
import { publicMenuApi } from '../services/publicMenuApi';
// Import the API services to ensure they're registered
import '../services/tablesApi';
import '../services/ordersApi';
import '../services/productsApi';
import '../services/validationApi';
import '../services/paymentMethodsApi';
import '../services/splitsApi';
import '../services/receiptsApi';
import '../services/aiChatApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    restaurant: restaurantReducer,
    tables: tablesReducer,
    orders: ordersReducer,
    products: productsReducer,
    notifications: notificationsReducer,
    theme: themeReducer,
    cloudPrint: cloudPrintReducer,
    dashboardPrivacy: dashboardPrivacyReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [autofacturaApi.reducerPath]: autofacturaApi.reducer,
    [publicMenuApi.reducerPath]: publicMenuApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(
      baseApi.middleware,
      autofacturaApi.middleware,
      publicMenuApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;